import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import ProductList from "./ProductList";

const Product = () => {
  return (
    <>
      <Navbar />
        <ProductList />
      <Footer />
    </>
  );
};

export default Product;
